import cn from 'classnames';
import { ClientEvents } from 'common/events/ClientEvents';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import LogoRaspberry from 'src/assets/svg/logo/logo-raspberry.svg';
import { useLocation } from 'src/shared/hooks/useLocation';
import { useTracker } from 'src/shared/hooks/useTracker';
import { Routes } from 'src/shared/Routes';

/** The catch-all page for unknown consumer URLs, with a link to the homepage. */
export const NotFoundPage: React.FC = () => {
  const { pathname, search } = useLocation();
  const tracker = useTracker();
  useEffect(() => {
    tracker.track(ClientEvents.PAGE_NOT_FOUND, {
      url: window.location.href,
      path: pathname,
      referrer: document.referrer || null,
    });
  }, [pathname, search, tracker]);

  return (
    <div
      className={cn(
        'fixed inset-0 flex min-h-24 flex-col items-center justify-center gap-4 overflow-y-auto p-4',
        'text-center text-neutral-800'
      )}>
      <Helmet>
        <title>Page not found | Shef</title>
        <meta name='robots' content='noindex' />
      </Helmet>
      <img src={LogoRaspberry} alt='Shef' className='h-12' />
      <h1 className='text-h4'>We couldn't find that page</h1>
      <p className='text-body-500'>The link may be out of date, or the page may have moved.</p>
      <a href={Routes.CONSUMER_LANDING} className='text-body-500 text-eggplant underline hover:text-eggplant-600'>
        Go to the homepage
      </a>
    </div>
  );
};

export default NotFoundPage;
